import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from '@/common/lang/en'
import zhLocale from '@/common/lang/zh'
import getLang from '@/lib/getBrowserLang'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({
  locale: getLang(), // set locale
  messages // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lib/i18.js